export enum AppPermissions {
  // Global permissions
  MANAGE_DEPARTMENTS = 'manage-departments',
  MANAGE_DEPARTMENT = 'manage-department',
  // Department specific permissions
  EDIT_PERMISSIONS = 'edit-permissions',
  EDIT_SCHEDULE = 'edit-schedule',
  VIEW_ALL_SCHEDULE_RESOURCES = 'view-all-schedule-resources',
  MANAGE_STAFF = 'manage-staff',
  MANAGE_CUSTOM_EVENTS = 'manage-custom-events',
  SEND_DAILY_SUMMARIES = 'send-daily-summaries',
  MANAGE_DAILY_AGENDA = 'manage-daily-agenda',
  START_DAILY_AGENDA_ROW_COMMENTS = 'start-daily-agenda-row-comments',
  MANAGE_EOD_REPORTS = 'manage-eod-reports',
  MANAGE_EVENT_NOTIFICATIONS = 'manage-event-notifications',
  MANAGE_ASSESSMENTS = 'manage-assessments',
  MANAGE_HOLIDAY_REQUESTS = 'manage-holiday-requests',
  MANAGE_TRAINING = 'manage-training',
  MANAGE_DEVIATIONS = 'manage-deviations',
  MANAGE_INCIDENTS = 'manage-incidents',
  VIEW_SALES_METRICS = 'view-sales-metrics',
  MANAGE_EXPERIENCES = 'manage-experiences',
  MANAGE_OPERATIONAL_BASES = 'manage-operational-bases',
  MANAGE_VEHICLES = 'manage-vehicles',
  VIEW_SCHEDULE = 'view-schedule',
  VIEW_STAFF_MANAGEMENT = 'view-staff-management',
  VIEW_ALERTS = 'view-alerts',
  VIEW_DAILY_AGENDA = 'view-daily-agenda',
  VIEW_DAILY_SUMMARY = 'view-daily-summary',
  VIEW_END_OF_DAY_REPORTS = 'view-end-of-day-reports',
  VIEW_DEVIATIONS = 'view-deviations',
  VIEW_EVENT_NOTIFICATIONS = 'view-event-notifications',
  VIEW_METRICS = 'view-metrics',
  VIEW_INCIDENTS = 'view-incidents',
  VIEW_ASSESSMENTS = 'view-assessments',
  VIEW_TRAINING = 'view-training',
  VIEW_EXPERIENCES = 'view-experiences',
  VIEW_OPERATIONAL_BASES = 'view-operational-bases',
  VIEW_MAPS = 'view-maps',
  MANAGE_MAPS = 'manage-maps',
  MANAGE_KNOWLEDGE_HUB = 'manage-knowledge-hub',
  CREATE_VEHICLE_CLEANING_LOG = 'create-vehicle-cleaning-log',
  CREATE_VEHICLE_ISSUE_REPORT = 'create-vehicle-issue-report',
  // vehicle maintenance
  MANAGE_VEHICLE_MAINTENANCE = 'manage-vehicle-maintenance',
  // Assignments
  VIEW_ASSIGNMENT_FEEDBACK_LOGS = 'view-assignment-feedback-logs',
  // Timesheets
  MANAGE_TIMESHEETS = 'manage-timesheets',
  // Hoeys
  VIEW_HOEYS = 'view-hoeys',
  MANAGE_HOEYS = 'manage-hoeys',
}
